import { render } from "./users-popup.vue?vue&type=template&id=133c5c49"
import script from "./users-popup.vue?vue&type=script&setup=true&lang=js"
export * from "./users-popup.vue?vue&type=script&setup=true&lang=js"

import "./users-popup.vue?vue&type=style&index=0&id=133c5c49&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/administration/users/users-popup.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "133c5c49"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('133c5c49', __exports__)) {
    api.reload('133c5c49', __exports__)
  }
  
  module.hot.accept("./users-popup.vue?vue&type=template&id=133c5c49", () => {
    api.rerender('133c5c49', render)
  })

}


export default __exports__